import './styles.scss'

import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Row, Space } from 'antd'

import { NotificationManager } from '@/components/Notification'
import { ProductService } from '@/services'
import { useAppSelector } from '@/store/hook'
import { selectIsProcurementTechnicalUserCxml } from '@/store/selectors/userSelector'
import useSessionBased from '@/hooks/useSessionBased'
import { getErrorData } from '@/libs/utils/errorUtils'
import sparePartImage from '@/assets/img/spare-parts.webp'

import BlockTwoCol from '../BlockTwoCol'
import { displayTypes } from '../BlockTwoCol/block-two-col.constants'
import CustomButton from '../CustomButton'

const ContentWrapper = (materialNumber, translation) => {
  const { t } = useTranslation()
  const { sessionId } = useSessionBased()
  const [isFetching, setIsFetching] = useState(false)
  const isTechnicalUserCXML = useAppSelector(
    selectIsProcurementTechnicalUserCxml,
  )
  const sparePartsOpenMode = isTechnicalUserCXML ? '_self' : '_blank'

  const getDisisLink = useCallback(async () => {
    try {
      setIsFetching(true)
      const { data } = await ProductService.getProductSpareParts(
        materialNumber,
        sessionId,
      )
      setIsFetching(false)
      window.open(data, sparePartsOpenMode)
    } catch (error) {
      setIsFetching(false)
      console.error('Error fetching spare parts:', error?.message)
      NotificationManager.error({
        message: 'notification.error.getProductSpareParts',
        description: getErrorData(error) as string,
      })
    }
  }, [materialNumber, sessionId, sparePartsOpenMode])

  const description = t('productDetails.spareParts.description').split('\n')
  const descriptionLines = description
    .map((v) => v.trim())
    .map((text, index) => ({ index, text }))

  const { allSparePart } = translation
  const allSparePartText = t(
    `productDetails.spareParts.button.${allSparePart}`,
  )
  return (
    <div>
      <h2 className="block-two-col__header mb-4">
        {t('productDetails.spareParts.title')}
      </h2>
      <div className="block-two-col__content mb-6">
        {descriptionLines.map((line) => <p key={line.index}>{line.text}</p>)}
      </div>
      <div className="block-two-col__footer">
        <Space className="block-two-col__btn-wrapper" direction="vertical">
          <CustomButton block loading={isFetching} onClick={getDisisLink}>
            {allSparePartText}
          </CustomButton>
        </Space>
      </div>
    </div>
  )
}

function ImagesWrapper() {
  return (
    <Row gutter={24}>
      <Col span={24}>
        <div
          className="spare-part-bg-img"
          style={{ backgroundImage: `url(${sparePartImage})` }}
        />
      </Col>
    </Row>
  )
}

interface B2becSparePartsProps {
  className?: string
  translation?: {
    allSparePart: string
  }
  materialNumber?: string | null
}

function B2becSpareParts({
  className = 'spare-parts',
  translation,
  materialNumber,
}: B2becSparePartsProps) {
  return (
    <div className="spare-parts-component__item">
      <BlockTwoCol
        className={className}
        left={ImagesWrapper()}
        right={ContentWrapper(
          materialNumber,
          translation ?? {
            allSparePart: 'allSparePart',
          },
        )}
        type={displayTypes.NORMAL}
      />
    </div>
  )
}

export default B2becSpareParts
